export default "__VITE_ASSET__DwVoBPmZ__"